import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Clock } from 'lucide-react';

const Artikel = () => {
    return (
        <div className="pt-24 min-h-screen bg-[#081c1a] animate-fade-in-up flex flex-col">
            <div className="container mx-auto px-6 py-8 flex-1">
                <Link to="/belajar-islam" className="inline-flex items-center gap-2 text-muted-foreground hover:text-gold transition-colors mb-10 group">
                    <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                    Kembali ke Belajar Islam
                </Link>

                {/* Coming Soon Content */}
                <div className="flex flex-col items-center justify-center min-h-[70vh] text-center">
                    {/* Decorative circles */}
                    <div className="relative mb-10">
                        <div className="w-40 h-40 rounded-full bg-blue-500/5 border border-blue-500/10 flex items-center justify-center mx-auto">
                            <div className="w-28 h-28 rounded-full bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
                                <FileText size={52} className="text-blue-400" />
                            </div>
                        </div>
                        <div className="absolute -top-2 -right-2 w-8 h-8 bg-gold/20 rounded-full border border-gold/40 flex items-center justify-center">
                            <Clock size={14} className="text-gold" />
                        </div>
                    </div>



                    <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6">
                        Segera <span className="text-gold">Hadir</span>
                    </h1>
                    <p className="text-xl text-muted-foreground max-w-xl leading-relaxed mb-10">
                        Berbagai artikel sedang dipersiapkan. Nantikan tulisan-tulisan bermanfaat yang disusun berdasarkan rujukan ilmiah. Insyallah. Barakallahufikum
                    </p>

                    <div className="flex flex-wrap gap-3 justify-center mb-12">
                        {['Aqidah', 'Fiqh', 'Muamalah', 'Akhlak', 'Sirah', 'Tazkiyatun Nafs'].map((tag) => (
                            <span key={tag} className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-muted-foreground text-sm">
                                {tag}
                            </span>
                        ))}
                    </div>

                    <div className="glass-card p-6 rounded-2xl border border-white/10 max-w-sm w-full">
                        <p className="text-muted-foreground text-sm mb-1">Tim kami sedang bersiap</p>
                        <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-blue-500 to-gold rounded-full" style={{ width: '35%' }} />
                        </div>
                        <p className="text-xs text-muted-foreground mt-2">35% selesai</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Artikel;
